/**
 * @author vishwadeep.kapoor
 * @Date: 2018-12-18 13:05:13
 * @Last Modified by: vishwadeep
 * @Last Modified time: 2019-01-07 13:14:33
 */

import { createSelector } from 'reselect';
import { utils } from '../../devUtils';

const selectNetworkCardsDomain = (state) => state.get('networkCards');
const selectNetworkCardsDetails = () => createSelector(
  selectNetworkCardsDomain,
  (NetworkCards) => NetworkCards,
);

// const select_transactions = () => createSelector(
//   selectNetworkCardsDomain,
//   (NetworkCards) => NetworkCards.get('transactions').toJS(),
// );

export const isNetworkCardLoading = () => createSelector(
  selectNetworkCardsDomain,
  (NetworkCards) => NetworkCards.get('isLoading'),
);

const select_card_data_ybl = () => createSelector(
  selectNetworkCardsDomain,
  (NetworkCards) => utils.immutableToJS(NetworkCards.get('cardDataYbl')),
);

const select_card_data_nsdl = () => createSelector(
  selectNetworkCardsDomain,
  (NetworkCards) => utils.immutableToJS(NetworkCards.get('cardDataNsdl')),
);

const select_card_data_ysc = () => createSelector(
  selectNetworkCardsDomain,
  (NetworkCards) => utils.immutableToJS(NetworkCards.get('cardDataYsc')),
);

const select_channel_flag_card_data_ybl = () => createSelector(
  selectNetworkCardsDomain,
  (NetworkCards) => utils.immutableToJS(NetworkCards.get('setChannelFlagData')),
);


const select_cardBlockJS = (key) => createSelector(
  selectNetworkCardsDomain,
  (NetworkCards) => utils.immutableToJS(NetworkCards.get(key)),
);

const select_isBoolean = (key) => createSelector(
  selectNetworkCardsDomain,
  (NetworkCards) => NetworkCards.get(key),
);

const select_beneficiariesList = () => createSelector(
  selectNetworkCardsDomain,
  (NetworkCards) => utils.immutableToJS(NetworkCards.get('beneficiariesList')),
);

const select_walletToImpsSuccess = () => createSelector(
  selectNetworkCardsDomain,
  (NetworkCards) => utils.immutableToJS(NetworkCards.get('walletToImpsSuccess')),
);

const select_ybl_otp_success = () => createSelector(
  selectNetworkCardsDomain,
  (NetworkCards) => NetworkCards.get('yblOtpSuccess').toJS(),
);

const select_ybl_otp_verified = () => createSelector(
  selectNetworkCardsDomain,
  (NetworkCards) => NetworkCards.get('ybl_otp_verified').toJS(),
);

const get_yes_bank_otp = (key) => createSelector(
  selectNetworkCardsDomain,
  (NetworkCards) => NetworkCards.get(key).toJS(),
);

const set_channel_flag = (key) => createSelector(
  selectNetworkCardsDomain,
  (NetworkCards) => NetworkCards.get(key).toJS(),
);

export {
  selectNetworkCardsDetails,
  select_isBoolean,
  select_cardBlockJS,
  select_beneficiariesList,
  select_walletToImpsSuccess,
  select_ybl_otp_success,
  select_ybl_otp_verified,
  get_yes_bank_otp,
  set_channel_flag,
  select_card_data_ysc,
  select_card_data_ybl,
  select_card_data_nsdl,
  select_channel_flag_card_data_ybl,
};



// WEBPACK FOOTER //
// client/containers/NetworkCards/selectors.js